<template>
  <div class="picklist">
    <el-select
      v-model="comselect"
      clearable
      :disabled="disabled"
      class="rt-saas-item-select"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="$_t(item.text,item.name)"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script type="text/javascript">
export default {
  props: ['dataFetch', 'entityName', 'selected', 'optionModel', 'isDisabled'],
  data: function () {
    return { options: [], comselect: this.selected, disabled: false };
  },
  computed: {
    modifyisDisabled: function () {
      return Boolean(this.isDisabled);
    }
  },
  watch: {
    selected: function (val) {
      this.comselect = val;
    },
    comselect: function (val) {
      this.$emit('selectitem', val);
    },
    optionModel: function (val) {
      this.options = val;
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.disabled = this.modifyisDisabled;
      this.bindPicklist();
    })
  },
  methods: {
    bindPicklist: function () {
      this.options = this.optionModel;
    }
  }
};
</script>

<style type="text/css"></style>



// WEBPACK FOOTER //
// picklist-component.vue?7bf457b8